// @flow
import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import throttle from 'lodash/throttle';
import SectionsTemplate from 'components/sections/SectionsTemplate';
import { type ContextRouter } from 'react-router-dom';
import SectionCurrentContainer from 'containers/sections/SectionCurrentContainer';
import SectionProductCards from 'containers/list/SectionProductCards';
import type { State } from 'store';
import { CommonActions } from 'store/actionCreators';
import type { SectionData } from 'store/modules/common';
import { getScrollBottom } from 'lib/common';

type OwnProps = {
  section: string,
};

type Props = OwnProps & {
  selected: ?SectionData,
  hasMore: boolean,
  pending: boolean,
} & ContextRouter;

class Sections extends Component<Props> {
  initialize = async () => {
    const { section } = this.props.match.params;
    try {
      await CommonActions.getSectionInfo(section);
    } catch (e) {
      console.log(e);
      if (e && e.response && e.response.status === 404) {
        this.props.history.replace('/404');
      }
    }
  };

  onScroll = throttle(() => {
    const scrollBottom = getScrollBottom();
    if (scrollBottom > 1000) return;
    const { selected, hasMore, pending } = this.props;
    if (!pending && hasMore && selected && selected.products) {
      this.loadMore();
    }
  }, 250);

  loadMore = async () => {
    const { section } = this.props.match.params;
    const { selected } = this.props;
    if (selected && selected.products) {
      const offset = selected.products.length;
      try {
        await CommonActions.getMoreSectionProducts(section, offset, 48);
      } catch (e) {
        console.log(e);
      }
    }
  };

  listenScroll = () => {
    window.addEventListener('scroll', this.onScroll);
  };

  unlistenScroll = () => {
    window.removeEventListener('scroll', this.onScroll);
  };

  componentDidMount() {
    this.initialize();
    this.listenScroll();
  }

  componentWillUnmount() {
    CommonActions.setSectionInfo(null);
    this.unlistenScroll();
  }

  render() {
    const { selected } = this.props;
    return (
      selected && (
        <SectionsTemplate>
          <Helmet>
            <title>{`${selected.title} | 캐시바이`}</title>
            <meta
              name="description"
              content={`캐시바이에 등록된 ${selected.title} 섹션의 상품을 보세요.`}
            />
          </Helmet>
          <Fragment>
            <SectionCurrentContainer selected={selected} />
            <SectionProductCards products={selected.products} />
          </Fragment>
        </SectionsTemplate>
      )
    );
  }
}

export default connect(
  ({ common, pender }: State) => ({
    selected: common.sections.selected,
    hasMore: common.sections.hasMore,
    pending: pender.pending['common/GET_MORE_SECTION_PRODUCTS'],
  }),
  () => ({}),
)(Sections);



// WEBPACK FOOTER //
// ./src/pages/Sections.js